import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { memo } from "react";
import { Invoice } from "@common/types/invoice";
import { NATIVE_INVOICE_TERM_TYPE_LABELS } from "@common/helpers/invoice-terms.helper";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";

export const TermsCell = memo(
    ({
        getValue,
    }: CellContext<ViewTableFeatures, Invoice, Invoice["termType"]>) => {
        const termType = getValue();
        return (
            <ViewTableCell>
                {termType ? NATIVE_INVOICE_TERM_TYPE_LABELS[termType] : ""}
            </ViewTableCell>
        );
    },
);
